module.exports = __webpack_public_path__ + "static/media/eye-close.7ddb58c1.svg";